import Column from '@components/Column';
import Header from '@components/Header';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import SignInFooter from './components/SignInFooter';
import SignInForm from './components/SignInForm';
import SignInContextProvider from './context/SignInContextProvider';

const SignInWithPhoneActivity: ActivityComponentType = () => (
        <SignInContextProvider>
            <AppScreen>
                <Column fullWidth fullHeight>
                    <Header title='로그인' />
                    <SignInForm/>
                    <SignInFooter/>
                </Column>
            </AppScreen>
        </SignInContextProvider>
);

export default SignInWithPhoneActivity;
